import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APUserModeAPIStrategy, RoleTypeStrategy } from '../strategies/user_mode_api_strategy';
import { VerifyAcademicPlanData } from '../validators/verify_academic_plan_data';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadAcademicPlanCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      $state: ng.ui.IStateService,
      updatePlanDataHelper: ng.IServiceProviderFactory,
      ngAPVerifyAcademicPlanData: VerifyAcademicPlanData,
      log: any
    ) => {
      return defineCommand('loadAcademicPlanCommand', (deferred, ap_plan_url) => {
        ap_plan_url =
          ap_plan_url ||
          _4.get(APUserModeAPIStrategy[RoleTypeStrategy.evaluate($state)], 'AP_PLAN_API_URL', 'reg/academicplan');
        $http
          .get(`${ap_plan_url}`)
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            return updatePlanDataHelper(response);
          })
          .then(() => deferred.resolve())
          .catch((e: ng.IHttpPromiseCallbackArg<any>) => {
            log.issue('failed to load academic plan');
            deferred.reject(e);
          })
          .finally(() => ngAPVerifyAcademicPlanData.verify());
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/commands/load_academic_plan_command.ts